//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from 'vuex'

export default {
  name: 'AppHeaderBag',

  props: {
    product: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      loading: false
    }
  },

  computed: {
    url() {
      return `/product/${this.product.id}/${this.product.slug}`
    }
  },

  methods: {
    ...mapActions('cart', ['remove']),

    async removeItem() {
      if (this.loading) {
        return
      }

      this.loading = true
      try {
        await this.remove(this.product.id)
      } finally {
        this.loading = false
      }
    }
  }
}
